import { ReactNode } from 'react';

export interface AccordionItem {
  title: ReactNode;
  content: ReactNode;
}
